import Vue from 'vue';

const success = (context, response, fromOnBoarding, $changedPwd) => {
  if (response && response.data && response.data.airlock && response.data.airlock.header_text) {
    if (fromOnBoarding) {
      context.user.onboarding_step = 7;
    } else if ($changedPwd) {
      context.smallLoading = false;
      context.changePwdStep = 3;
    } else {
      context.activeStep = 4;
    }
    toastr.success(response.data.airlock.header_text);
  }
};

const failed = (context, error, fromOnBoarding, $changedPwd) => {
  context.loading = false;
  if (fromOnBoarding) {
    context.user.onboarding_step = 6;
  } else if ($changedPwd) {
    context.changePwdStep = 2;
  } else {
    context.activeStep = 3;
  }
  toastr.error(context.$t('account.settings.user_platforms_section.send_verification_code_error'));
};

export default (context, data, generalData, randomDeviceId, fromOnBoarding = false, $changedPwd = false) => {
  const dataSend = {
    methodData: data,
    generalData,
    randomDeviceId,
  };
  return Vue.$http.post('verify-airbnb-account-phone', dataSend)
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response.data, fromOnBoarding, $changedPwd);
      } else {
        failed(context, response.data, fromOnBoarding, $changedPwd);
      }
    }).catch((error) => {
      failed(context, error, fromOnBoarding, $changedPwd);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/account/verifyAirbnbAccountViaPhoneOrEmail.js